<button class="button" (click)="showParentFilter()">
    <i class="fas fa-search"></i>
</button>
@if (parentFilter?.values?.length) {
    <div class="listingStatusFilterWrapper">
        @for (filterValue of parentFilter.values; track filterValue) {
            <app-listing-status-filter [parentFilterValue]="filterValue" [isFloatingFilterIcon]="true" />
        }
    </div>
}
